import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {GetTenantV2ApiRes, Locale} from '@dms/api/base';

type TenantLocaleConfig = Pick<GetTenantV2ApiRes, 'availableLocales' | 'defaultLocale'>;

/**
 * The `defaultLocale` fallback matters: `availableLocales` can come back empty, and a
 * screen rendering one field group per locale would then render none — skipping
 * validation and letting the user save content that can never be delivered.
 */
export const getAvailableLocales = (tenant: TenantLocaleConfig | undefined): Locale[] =>
  match(tenant)
    .when(
      (currentTenant) => isNotNilOrEmpty(currentTenant?.availableLocales),
      (currentTenant) => currentTenant?.availableLocales ?? []
    )
    .when(
      (currentTenant) => isNotNil(currentTenant?.defaultLocale),
      (currentTenant) => {
        const defaultLocale = currentTenant?.defaultLocale;

        return isNotNil(defaultLocale) ? [defaultLocale] : [];
      }
    )
    .otherwise(() => []);
